export type ThemePreference = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

export type ThemeResolution = {
  preference: ThemePreference;
  systemDark: boolean;
  darkAllowed: boolean;
};

export function resolveTheme({
  preference,
  systemDark,
  darkAllowed,
}: ThemeResolution): ResolvedTheme {
  if (!darkAllowed) return 'light';
  if (preference === 'system') return systemDark ? 'dark' : 'light';
  return preference;
}

export function applyTheme(root: HTMLElement, theme: ResolvedTheme): void {
  if (theme === 'dark') root.dataset['theme'] = 'dark';
  else delete root.dataset['theme'];
  root.style.colorScheme = theme;
}
